// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-search-date[data-v-56217bdd]{margin-top:16px}", "",{"version":3,"sources":["webpack://./resources/js/components/profits/ProfitSearchDate.vue"],"names":[],"mappings":"AACE,mCACE,eAAJ","sourcesContent":["\n  .form-search-date {\n    margin-top: 16px;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
